import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";
import { TestimonialForm } from "./TestimonialForm";
import { TestimonialItem } from "./TestimonialItem";

export function TestimonialsManager({ pageId, admin }) {
  const [items, setItems] = useState(null);
  const [adding, setAdding] = useState(false);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/testimonials", { params: { page_id: pageId } });
      setItems(data.items || []);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setItems([]);
    }
  }, [pageId]);
  useEffect(() => { load(); }, [load]);

  const live = (items || []).filter((t) => t.status === "approved").length;
  return (
    <div data-testid={`testimonials-manager-${pageId}`}>
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <span className="text-xs text-zinc-600" data-testid={`testimonials-live-count-${pageId}`}>
          {live} live · shown on the landing pages and thank-you page{live ? "" : " — the section stays hidden until one is live"}
        </span>
        {!adding && (
          <button type="button" onClick={() => setAdding(true)} data-testid={`testimonials-add-${pageId}`}
                  className="sm:ml-auto border-2 border-black bg-black text-white px-2.5 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 hover:bg-zinc-800">
            <Plus size={11} weight="bold" /> Add testimonial
          </button>
        )}
      </div>
      {adding && (
        <TestimonialForm pageId={pageId} admin={admin} testId={`testimonial-new-${pageId}`}
                         onSaved={() => { setAdding(false); load(); }} onCancel={() => setAdding(false)} />
      )}
      <div className="flex flex-col gap-2 mt-2">
        {items === null && <div className="label-mono">Loading…</div>}
        {items?.length === 0 && !adding && <div className="text-xs text-zinc-500" data-testid={`testimonials-empty-${pageId}`}>No testimonials yet.</div>}
        {(items || []).map((t) => <TestimonialItem key={t.id} t={t} admin={admin} onChanged={load} />)}
      </div>
    </div>
  );
}
